import { parseJsonObject } from "../../../features/builder.utils";
import { ADD_OPS, DIFF_OPS } from "./source-field.constants";

// Pure helpers of the computed field form (no API, no React).

/** The data type a calculation produces. latest_value takes the type of the column it reads. */
export const resultTypeOf = (values) => {
  if (ADD_OPS.includes(values.op)) return "DATE";
  if (DIFF_OPS.includes(values.op) || values.op === "count_relation") return "INT";
  if (values.op === "latest_value") return values.latest_type || null;
  return null;
};

const relationOfOption = (value) => String(value ?? "").split(".")[0];
const columnOfOption = (value) => String(value ?? "").split(".").slice(1).join(".");

/** The compute object of the chosen operation, with only the keys that operation reads. */
export function toCompute(values) {
  const op = values.op;
  if (ADD_OPS.includes(op)) {
    return { op, base: values.base, ...(values.amount_mode === "field" ? { amount_path: values.amount_path } : { amount: Number(values.amount) }) };
  }
  if (DIFF_OPS.includes(op)) return { op, from: values.from, ...(values.to ? { to: values.to } : {}) };
  if (op === "count_relation") {
    const where = parseJsonObject(values.where_text ?? "");
    return { op, relation: values.relation, ...(where ? { where } : {}) };
  }
  const hasDefault = values.default_value !== undefined && values.default_value !== null && String(values.default_value).trim() !== "";
  const numeric = ["INT", "NUMERIC"].includes(values.latest_type);
  return {
    op,
    relation: relationOfOption(values.latest_column),
    field: columnOfOption(values.latest_column),
    order_by: values.order_by ? columnOfOption(values.order_by) : "id",
    ...(hasDefault && { default: numeric ? Number(values.default_value) : String(values.default_value).trim() }),
  };
}

/** EntityFormModal values -> create (with source_fid) / update payload. */
export const toComputedFieldPayload = (values, sourceFid = null) => {
  const resultType = resultTypeOf(values);
  return {
    ...(sourceFid && { source_fid: sourceFid }),
    field_key: values.field_key?.trim() ?? "",
    label: values.label?.trim() ?? "",
    compute: toCompute(values),
    field_role: values.field_role || "ATTRIBUTE",
    format: values.format || (resultType === "DATE" ? "date" : resultType === "TIMESTAMP" ? "datetime" : null),
    description: values.description?.trim() || null,
    is_filterable: !!values.is_filterable,
    is_template_var: !!values.is_template_var,
    ...(values.sort_order !== "" && values.sort_order !== null && values.sort_order !== undefined && { sort_order: Number(values.sort_order) }),
  };
};

/** Form values of a saved computed field (EntityFormModal editValue). */
export const computeFormValues = (compute) => {
  const c = compute ?? {};
  return {
    op: c.op ?? "",
    base: c.base ?? "",
    amount_mode: c.amount_path ? "field" : "fixed",
    amount: c.amount ?? "",
    amount_path: c.amount_path ?? "",
    from: c.from ?? "",
    to: c.to ?? "",
    relation: c.relation && c.op === "count_relation" ? c.relation : "",
    where_text: c.where ? JSON.stringify(c.where, null, 2) : "",
    latest_column: c.op === "latest_value" && c.relation && c.field ? `${c.relation}.${c.field}` : "",
    order_by: c.op === "latest_value" && c.relation ? `${c.relation}.${c.order_by || "id"}` : "",
    default_value: c.default ?? "",
  };
};
